import React, {Component,Fragment} from 'react';
import {Link} from 'react-router-dom';
import $ from 'jquery'
import Modal from 'react-modal';
import Phone from 'react-phone-number-input';
import active from "../../../assets/img/active.png";
import NotificationSystem from 'react-notification-system';
import warn from "../../../assets/img/warning.png";
import deleted from "../../../assets/img/invalid.png";
import ToggleDisplay from 'react-toggle-display';
import {BeatLoader} from 'react-spinners';
import {_addNotification,_addNotificationError,numberOnly} from '../../../server/util';
import {dial_code, mobileNoLength,BASE_URL_2,access_token} from '../../../server/constants'
import {get,postWithHeaders,postWithHeadersResponse,put} from "../../../server/actions";
let schoolId=0;
let loggedUser = '';
let userName = "";
let userID = "";
let oldPin = "";
let adminData = '';
let restoreCol = {};
const customManageUsersStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};
const tickstyles = {
    width: '20px',
    height: '20px',
    lineHeight: '20px',
    textAlign: 'center',
    borderRadius: '20%',
    color: '#ffffff',
    fontSize: '14px',   
};
function pinFormtFun() {
    $("#pin").keyup(function() {
        $("#pin").val(this.value.match(/[0-9]*/));
    });
}
function cPinFormtFun() {
    $("#cpin").keyup(function() {
        $("#cpin").val(this.value.match(/[0-9]*/));
    });
}
class ManageUsers extends Component {
    constructor(props){
        super(props);
        this.state={
            loading: false,
            mobileLength:mobileNoLength(),
            //loggedUser: {},
            schoolList: [],
            modalManageUsersIsOpen: false,
            actionType: '',
            schoolUsers: [{
                firstName: '',
                lastName: '',
                username: '',
                mobileNo: '',
                isPrimaryUser:true,
                isUnsubscribeGenNotif:false,
                role: "ROLE_ADMIN",
                
            }],
            pin:'',
            modalIsOpen: false,
            show: false,
            modalPinChangeIsOpen: false,
        }
        this.getDataSyncFieldMap=this.getDataSyncFieldMap.bind();
        this.handleSubmit = this.handleSubmit.bind(this);
        this.openModal = this.openModal.bind(this);
        this.onPrimaryAcClicked=this.onPrimaryAcClicked.bind();
        this.checkPin = this.checkPin.bind(this);
    }
    componentDidMount = () => {
        
        if(sessionStorage.getItem('ROLE')==='ROLE_SUPERADMIN'){
            schoolId=this.props.school._links.self.href.split('/').pop();
            this.setState({schoolName:'['+this.props.school.schoolName+']'})
        }
        else{
            schoolId=sessionStorage.getItem('SchoolId');
        }
        this.getDataSyncFieldMap();
        this._notificationSystem = this.refs.notificationSystem;
    }
    componentWillMount(){        
        loggedUser = sessionStorage.getItem('loggedInUserInfo') || '';
    }
    getDataSyncFieldMap=()=>{  
        this.setState({loading: true});      
        get('/mealSchools/' + schoolId + '?access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            console.log('data', data);
            this.setState({
                schoolList: data.schoolUsers ,
                loading: false
            })             
        }).catch(
            (error) => {  
                this.setState({loading: false});              
                console.log('Get Users data response', error)
            }
        );
    }
    addNewUsers = (e, userType, actionType) =>{
        e.preventDefault();
        if(userType !== ''){
            this.setState({
                schoolUsers: [{
                    firstName: userType.firstName,
                    lastName: userType.lastName,
                    username: userType.username,
                    mobileNo: (userType.mobileNo||'').substr(-this.state.mobileLength),
                    isPrimaryUser:userType.isPrimaryUser,
                    isUnsubscribeGenNotif:userType.isUnsubscribeGenNotif,
                    role: userType.role
                }]
            });
        }else{
            this.setState({
                schoolUsers: [{
                    firstName: '',
                    lastName: '',
                    username: '',
                    mobileNo: '',
                    isPrimaryUser:true,
                    isUnsubscribeGenNotif:false,
                    role: "ROLE_ADMIN"
                }]
            });
        }
        this.setState({modalManageUsersIsOpen:true, actionType:actionType});      
    }
    handleFirstNameChange = (idx) => (evt) => {
        const newUser = this.state.schoolUsers.map((user, sidx) => {
            if (idx !== sidx) return user;
            return {...user, firstName: evt.target.value};
        });

        this.setState({schoolUsers: newUser});
    };
    handleLastNameChange = (idx) => (evt) => {
        const newUser = this.state.schoolUsers.map((user, sidx) => {
            if (idx !== sidx) return user;
            return {...user, lastName: evt.target.value};
        });

        this.setState({schoolUsers: newUser});
    };
    handlePhoneChange = (idx) => (evt) => {
       // let input = document.getElementById('mobileNum');
       // input.oninput = function (event) {
       //     event.target.setCustomValidity('')
      //  }
       // input.oninvalid = function (event) {
       //     event.target.setCustomValidity('Please enter a valid mobile number');
       // }
       // if (evt) {
            const newUser = this.state.schoolUsers.map((user, sidx) => {
                if (idx !== sidx) return user;
                return {...user, mobileNo: evt.target.value};
            });           
            this.setState({schoolUsers: newUser});
       // }
    };
    handleUserNameChange = (idx) => (evt) => {
        const newUser = this.state.schoolUsers.map((user, sidx) => {
            if (idx !== sidx) return user;
            return {...user, username: evt.target.value};
        });

        this.setState({schoolUsers: newUser});
    };
    handlePinChangeValue(e) {
        this.state.pin = e.target.value;
    }
    checkPin = () => {
        if (document.getElementById('pin').value ===
            document.getElementById('cpin').value) {
            document.getElementById('pinMessage').innerHTML = '';
            document.getElementById("submitPin").disabled = false;
        } else {
            document.getElementById('pinMessage').style.color = 'red';
            document.getElementById('pinMessage').innerHTML = 'Pins do not match';
            document.getElementById("submitPin").disabled = true;
        }
        if (document.getElementById('pin').value === '') {
            document.getElementById('pinMessage').innerHTML = '';

        }
    }
    onUnsubscribeClicked=(idx)=>(evt)=>{
        let userslist=this.state.schoolUsers
        userslist[idx].isUnsubscribeGenNotif=evt.target.checked;
        this.setState({schoolUsers: userslist});
    }
    onPrimaryAcClicked=(idx)=>(evt)=>{
        let userslist=this.state.schoolUsers
        userslist[idx].isPrimaryUser=evt.target.checked;
        this.setState({schoolUsers: userslist});
    }
    sendAdminLinks = (col,username) => {
        console.log(JSON.stringify(col, null, 2))
        this.setState({loading: true});      
        get('/adminAccActivationInfo?schoolId=' + schoolId + '&loggedUser=' + JSON.parse(loggedUser).username +'&schoolUserName='+username+ '&access_token=').then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                console.log('response', response);
                return response;
            }).then(data => {
                _addNotification('Successfully sent emails.', this);
                this.setState({loading: false});
                console.log('Access Links Sent', data);
            }).catch(
                    (error) => {
                        _addNotificationError('Send links failed. Please try again later.', this);
                        console.log('Send Notification Links response', error)
                    });
    };
    handleClick = () => {       
        this.setState({
            show: !this.state.show
        })

    }
    // getDeletedSchools = () => {
    //     this.state.deletedSchoolList = [];
    //     get('/mealSchools/search/findByIsActive?isActive=false&page=0&size=2147483647&access_token=').then((response) => {
    //         if (!response.ok) {
    //             throw Error(response.statusText);
    //         }
    //         console.log('response', response);
    //         return response.json();
    //     }).then(data => {
    //         console.log('Json returned from getSchoolList', data);           
    //         let protocal = "https://";
    //         let mainDomain = "mealmanage.com";

    //         data._embedded.mealSchools.forEach(obj => {               
    //             obj.adminurl = protocal + obj.subdomain + "." + mainDomain;              
    //             this.setState({deletedSchoolList: [...this.state.deletedSchoolList, obj]});
    //         })
    //         console.log('SchoolList', this.state.deletedSchoolList);
    //     })
    //         .catch(
    //             (error) => {
    //                 console.log('Get SchoolList response', error)
    //             }
    //         )

    // }
    closeManageUsersModal = (e) => {
        e.preventDefault();
        this.setState({ modalManageUsersIsOpen: false }); 
    }
    closePinChangeModal = (e) => {
        e.preventDefault();
        this.setState({ modalPinChangeIsOpen: false }); 
    }
    openModal(col) {
        //alert(JSON.stringify(col,null,2))
        userName = col.username;
        this.setState({modalIsOpen: true});

    }
    openPinModal(col) {
        userID = col.displayRecId
        oldPin = col.pin
        
        this.setState({modalPinChangeIsOpen: true});

    }
    deleteUser = () => {
        this.setState({loading: true});      
        get('/enableDisableSchoolUser?schoolUserName=' + userName + '&activeStatus=false&loggedUser=' + JSON.parse(loggedUser).username + '&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response;
        }).then(data => {
            _addNotification('Successfully deactivated admin.', this);
            //this.getSchoolList();
            this.setState({
                loading: false,
                modalIsOpen: false
            });
            this.getDataSyncFieldMap();
            console.log('Access Links Sent', data);
        })
            .catch(
                (error) => {
                    _addNotificationError('Deactivation failed. Please try again later.', this);
                    console.log('Send Notification Links response', error)
                }
            )
    }
    restoreAdminUser = (col) => {
        this.setState({modalRestoreIsOpen:true});
        userName = col.username;
        restoreCol = col;
    }
    restoreAdminUsers = () => {
        this.restoreUser(restoreCol);
    }
    restoreUser= (col) => {
        this.setState({loading: true});      
        get('/enableDisableSchoolUser?schoolUserName=' + col.username + '&activeStatus=true&loggedUser=' + JSON.parse(loggedUser).username + '&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response;
        }).then(data => {
            _addNotification('User restored Successfully.', this);
            //this.getSchoolList();
            this.setState({
                loading: false,
                modalRestoreIsOpen: false
            });
            this.getDataSyncFieldMap();
            //console.log('Access Links Sent', data);
        })
            .catch(
                (error) => {
                    _addNotificationError('Activation failed. Please try again later.', this);
                    console.log('Send Notification Links response', error)
                }
            )
    }
    handleSubmit(event) {
        document.getElementById("submit").disabled = true;
        event.preventDefault();
        this.setState({loading: true});
        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };
        if(this.state.schoolUsers[0].mobileNo.length!==0 && this.state.schoolUsers[0].mobileNo.length<this.state.mobileLength){
            _addNotificationError('Please provide valid mobile no.', this);
            document.getElementById("submit").disabled = false;
            return false;
        }
        let formData = {
            loggedUser: JSON.parse(loggedUser).username,
            isPaymentEnabled:null,
            schoolUsers:[{username:this.state.schoolUsers[0].username,
                               firstName:this.state.schoolUsers[0].firstName,
                               lastName:this.state.schoolUsers[0].lastName,
                               mobileNo:this.state.schoolUsers[0].mobileNo.length>0?dial_code()+this.state.schoolUsers[0].mobileNo:'',
                               isUnsubscribeGenNotif:this.state.schoolUsers[0].isUnsubscribeGenNotif,
                               isPrimaryUser:this.state.schoolUsers[0].isPrimaryUser
                              }]
            }
        postWithHeaders('/mealSchoolUpdate?mealSchoolId=' + schoolId + '&access_token=', JSON.stringify(formData), headers).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response;
        }).then(data => {
            _addNotification('Successfully updated user data.', this);
            this.setState({loading: false,modalManageUsersIsOpen: false});
            this.getDataSyncFieldMap();
        })
            .catch(
                (error) => {
                    document.getElementById("submit").disabled = false;
                    this.setState({loading: false});
                    _addNotificationError('Could not updated user data.', this);
                    console.log('Onboard User response', error)
                }
            )
       
    }
    handlePinSubmit(event,userID,oldPin) {
        event.preventDefault();
        this.setState({loading: true});
        let pin= document.getElementById("pin").value;
        if(oldPin!=pin){
        put(`/${schoolId}/${userID}/generateAdminPIN?pin=${pin}&access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response;
        }).then(data => {
           /*  this.state.loggedUser.pin = pin
            sessionStorage.setItem('loggedInUserInfo', JSON.stringify(this.state.loggedUser)) */
            _addNotification('Successfully updated Pin.', this);
            this.setState({loading: false,modalPinChangeIsOpen: false});
            this.getDataSyncFieldMap();
        })
            .catch(
                (error) => {
                    this.setState({loading: false});
                    _addNotificationError('Could not update Pin.', this);
                }
            )   }
            else{
                this.setState({loading: false});
                _addNotificationError('Use new Pin.', this);
            }
    }
    generatePin(userID) {
        put(`/${schoolId}/${userID}/generateAdminPIN?access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            _addNotification('Successfully Generated Pin.', this);
            this.setState({loading: false});
            this.getDataSyncFieldMap();

        }).catch(
            (error) => {
                _addNotificationError('Unable to Generate Pin ! Try Again.', this);
                console.log('Generate Pin data response', error)
            }
        );
    }
    render() {
        return (
            <div> 
            <NotificationSystem ref="notificationSystem"/>
            <div className='sweet-loading' style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000   '}}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
            <div className="container">
            <div className="row">
                        <div className="col-md-6 col-sm-12 col-xs-12 sectionTitle">
                        <h2>
                            <span>Manage Users</span>
                        </h2>
                        </div>
                        <div className="col-md-6 col-sm-12 col-xs-12 button-group-section" style={{marginTop:'15px'}}>
                            <button className="btn btn-success button-sm add-btn-sm"
                                   onClick={(e)=>this.addNewUsers(e, '', "NEW")} ><i className="fa fa-user-plus"/> Add User</button>
                        </div>
            <div className="col-md-12 col-sm-12 col-xs-12">
                    <div className="table-responsive ">
                    <table className="table table-hover">
                                    <thead>
                                    <tr className="bg-success base-reverse">
                                        <th>NAME</th>                                    
                                        <th>PHONE</th>
                                        <th>EMAIL ID</th>
                                        <th className="text-center">UNSUBSCRIBE</th>
                                        <th>PIN</th>
                                        <th className="text-center">ACTION</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <div id="noSchool" style={{display: 'none'}} className="noSchool">
                                        <span>Oops, We found nothing. Try Adding new users.</span>
                                    </div>

                                    {
                                        this.state.schoolList.map(col =>{
                                            let userID = col.displayRecId
                                            let userr = col.username
                                            sessionStorage.setItem('usernamedel', userr);
                                            if(/* col.isPaymentRegister!=true && */ col.isActive)
                                            return (<tr>
                                                <td>{col.firstName} {col.lastName}</td>                                              
                                                <td>{col.mobileNo}</td>
                                                <td><div>
                                                        <span>                                                          
                                                                <img alt="action"
                                                                     onClick=""
                                                                     src={col.isActive === true ? (col.isVerified === true ? active : warn) : deleted}
                                                                     style={{
                                                                         paddingRight: '5px',
                                                                         cursor: 'pointer',
                                                                         width: '22px'
                                                                     }}/>
                                                                {col.username}                                                        
                                                            </span>
                                                        </div></td>
                                                <td className="text-center">{col.isUnsubscribeGenNotif ? <i className="fa fa-check bg-color-2" style={tickstyles} aria-hidden="true"></i>:<i className="fa fa-times bg-color-light-grey" style={tickstyles} aria-hidden="true"></i>}</td>
                                                <td>
                                                {
                                                col.pin!= null ?
                                                <div><span>{col.pin} <a style={{ color: '#757576'}} onClick={(e)=>{this.openPinModal(col,col.displayRecId,col.pin)}} title="Edit Pin" ><i class="fa fa-pencil" aria-hidden="true"></i></a></span></div>
                                                :<Fragment>           
                                                <span><a onClick={()=>this.generatePin(userID)} style={{ color: 'rgb(61 55 55)'}} title="Generate pin"><i  class="fa fa-refresh" aria-hidden="true"></i></a></span>
                                                </Fragment>
                                                }
                                                </td>
                                                <td className="actions text-center" style={{whiteSpace: 'nowrap'}}>
                                                    <div>
                                                    {  (col.isPaymentRegister!=true || col.isPrimaryUser!=true) ?
                                                    <Fragment>
                                                        <a className="edit-btn"
                                                       /* style={{  pointerEvents: 'none', cursor: 'not-allowed',}} */
                                                              onClick={(e)=>this.addNewUsers(e, col, "EDIT")}><i
                                                            className="fa fa-pencil-square-o tbl-rounded-icon bg-color-1 fa-icon"/></a>  
                                                                                             
                                                        <a className="delete-btn"
                                                           onClick={() => this.openModal(col)}><i
                                                            className="fa fa-trash-o tbl-rounded-icon bg-color-3 fa-icon"/></a></Fragment>:
                                                            <Fragment>
                                                        <a className="edit-btn" 
                                                        style={{  pointerEvents: 'none', cursor: 'not-allowed'}} 
                                                              onClick={(e)=>this.addNewUsers(e, col, "EDIT")}><i
                                                            className="fa fa-pencil-square-o tbl-rounded-icon bg fa-icon"/></a>  
                                                                                             
                                                        <a className="delete-btn"  
                                                        style={{  pointerEvents: 'none', cursor: 'not-allowed'}} 
                                                           onClick={() => this.openModal(col)}><i
                                                            className="fa fa-trash-o tbl-rounded-icon bg fa-icon"/></a></Fragment>}
                                                        <a className="edit-btn"
                                                              onClick={() => this.sendAdminLinks(col,col.username)}><i
                                                            className="fa fa-paper-plane-o tbl-rounded-icon btn-warning fa-icon"/></a>
                                                            
                                                    </div>
                                                </td>
                                            </tr>)
                                        })
                                    }
                                    </tbody>
                                </table>

                    </div>
                
            </div>
                                <Modal
                                    isOpen={this.state.modalManageUsersIsOpen}
                                    //onAfterOpen={this.afterManageUsersOpenModal}
                                  //  onRequestClose={() => this.setState({ modalManageUsersIsOpen: false })}
                                    style={customManageUsersStyles}
                                    contentLabel="Activation"
                                >
                                    <div className="modal-header">
                                        <h4 className="modal-title modal-title-color col-md-6" id="deleteLabel">User</h4>
                                   <div className="col-md-6"><button type="button" className="pull-right color-1" onClick={(e)=>this.closeManageUsersModal(e)}>X</button></div>
                                    </div>
                                    <div className="modal-body">
                                    <form onSubmit={this.handleSubmit}>
                                    <div>                                   
                                        {this.state.schoolUsers.map((user, idx) => {
                                            //if(user.isPrimaryUser)
                                            return (<div>
                                                  {/* {this.state.actionType === "NEW" && idx >= 1 ?
                                                    <div className="pull-right">
                                                        <i className="fa fa-close fa-2x"
                                                           onClick={this.handleRemoveUser(idx)}
                                                           style={{
                                                               margin: '0px 12px',
                                                               cursor: 'pointer',
                                                               color: '#f45f3a'
                                                           }}
                                                        />
                                                    </div> : ''}
                                                {this.state.actionType === "EDIT" && idx >= this.state.schoolUsers.length ?
                                                    <div className="pull-right">
                                                        <i className="fa fa-close fa-2x"
                                                           onClick={this.handleRemoveUser(idx)}
                                                           style={{
                                                               margin: '0px 12px',
                                                               cursor: 'pointer',
                                                               color: '#f45f3a'
                                                           }}
                                                        />
                                                    </div> : ''}   */}
                                                <div className="form-group">
                                                    <label className="control-label" htmlFor="county">First
                                                        Name*</label>
                                                    <input type="text" name="firstName"
                                                           className="form-control border-color-1 rounded" id="fname"
                                                           placeholder="First Name" value={user.firstName}
                                                           onChange={this.handleFirstNameChange(idx)} required/>
                                                </div>
                                                <div className="form-group">
                                                    <label className="control-label" htmlFor="district">Last
                                                        Name*</label>
                                                    <input type="text" name="lastName"
                                                           className="form-control border-color-1 rounded" id="lname"
                                                           placeholder="Last Name" value={user.lastName}
                                                           onChange={this.handleLastNameChange(idx)} required/>
                                                </div>
                                                <div className="form-group">
                                                    <label className="control-label" htmlFor="county">Phone*</label>
                                                    <input type="text" 
                                                                className="form-control"
                                                                value={user.mobileNo}
                                                                id="mobileNum"
                                                                placeholder={'Mobile Number'}
                                                                onChange={this.handlePhoneChange(idx)}
                                                                maxLength={10}
                                                                onKeyPress={numberOnly} required />
                                                    {/* <Phone
                                                        id="mobileNum"
                                                        className="form-control"
                                                        value={user.mobileNo}
                                                        country={this.state.actionType === "NEW" ? 'US' : ''} // todo: Need to use this {this.props.school.actionType === "NEW" ? 'US': ''} as we don't need default country for edit
                                                        countries={['US', 'CA']}
                                                        placeholder={`Mobile Number`}
                                                        onChange={this.handlePhoneChange(idx)}
                                                        smartCaret={false}
                                                        displayInitialValueAsLocalNumber={true}
                                                        pattern="^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$" //only for us
                                                        maxlength="15"
                                                        nativeExpanded={true}
                                                        //title="Please enter valid mobile number"
                                                        required/> */}
                                                </div>
                                                <div className="form-group">
                                                    <label className="control-label" htmlFor="school">Email ID*</label>
                                                    <input type="email" name={user.username}
                                                           pattern="[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$"
                                                           className="form-control border-color-1 rounded"
                                                           placeholder="Email ID" value={user.username}
                                                           onChange={this.handleUserNameChange(idx)} disabled={this.state.actionType === 'EDIT' ? true:false} required/>
                                                    <span id={user.username} className="validateMessage"></span>
                                                </div>
                                                 <div className="checkbox col-sm-12" style={{padding:'0'}}>
                                                <label style={{fontWeight: '700'}}>
                                                <input type="checkbox" class="radio" checked={user.isPrimaryUser} onClick={this.onPrimaryAcClicked(idx)} name="isPrim" />Is Primary Account?</label>
                                                </div> 
                                                <div className="checkbox col-sm-12" style={{marginTop:'10px',padding:'0'}}>
                                                <label style={{fontWeight: '700'}}>
                                                <input type="checkbox" class="radio" checked={user.isUnsubscribeGenNotif} onClick={this.onUnsubscribeClicked(idx)} name="isUnsubscribeGenNotif" />Unsubscribe For General Notifications </label>
                                                </div>


                                                <div className="form-group col-sm-12">
                                                    <hr style={{color: 'lightgray !important'}}/>
                                                </div>
                                            </div>)
    })}
                                        {/* <div className="form-group col-md-12 pull-left">
                                            <a onClick={this.handleAddUser} style={{cursor: 'pointer'}}>Add User
                                            </a>
                                        </div> */}
                                    </div>
                                    <div className="col-md-12 col-sm-12 col-xs-12">
                                        <a href="javascript:void(0);" className="pull-left">
                                            <button className="btn btn-primary btn-sm" type="button" onClick={(e)=>this.closeManageUsersModal(e)}
                                                    style={{margin: 0, fontSize: 14}}>Back
                                            </button>
                                        </a>

                                        <button className="btn btn-success btn-sm pull-right" id="submit"
                                                type="submit" style={{margin: 0, fontSize: 14}}>Finish
                                        </button>
                                    </div>
                                </form>
                                    </div>          
                                </Modal>
                                
                                <Modal
                                    isOpen={this.state.modalIsOpen}
                                   // onAfterOpen={this.afterOpenModal}
                                    // onRequestClose={this.closeModal}
                                    style={customManageUsersStyles}
                                >
                                    <div className="modal-header">
                                        <h4 className="modal-title modal-title-color col-md-6" id="deleteLabel">Delete
                                            User</h4>
                                            <div className="col-md-6"><button type="button" className="pull-right color-1" onClick={() => this.setState({modalIsOpen: false})}>X</button></div>
                                    </div>
                                    <div className="modal-body">
                                        <p>Are you sure you want to delete this user <b><i>'{userName}'</i></b> from Meal Manage service?<br/>
                                            <b><i>You can restore user again from deleted users tab</i></b></p>
                                    </div>
                                    <div className="modal-footer">
                                        <form>
                                            <button type="button" className="btn btn-sm btn-success"
                                                    onClick={() => this.setState({modalIsOpen: false})}
                                                    style={{margin: 0, fontSize: 14}}><i
                                                className="glyphicon glyphicon-remove"/> Cancel
                                            </button>
                                            <button type="button" className="btn btn-sm btn-danger"
                                                    onClick={this.deleteUser}
                                                    style={{margin: 0, marginLeft: 5, fontSize: 14}}><i
                                                className="glyphicon glyphicon-ok"/> Delete
                                            </button>
                                        </form>
                                    </div>
                                </Modal> 
                                <Modal
                                    isOpen={this.state.modalRestoreIsOpen}
                                    onAfterOpen={this.afterRestoreOpenModal}
                                    // onRequestClose={this.closeRestoreModal}
                                    style={customManageUsersStyles}
                                    contentLabel="Activation"
                                >
                                    <div className="modal-header">
                                        <h4 className="modal-title modal-title-color col-md-6" id="deleteLabel">Restore
                                            User</h4>
                                            <div className="col-md-6"><button type="button" className="pull-right color-1"  onClick={() => this.setState({modalRestoreIsOpen: false})}>X</button></div>
                                    </div>
                                    <div className="modal-body">
                                        <p>Are you sure you want to restore this user <b><i>'{userName}'</i></b></p>      
                                    </div>
                                    <div className="modal-footer">
                                        <form>
                                            <button type="button" className="btn btn-sm btn-success"
                                                    onClick={() => this.setState({modalRestoreIsOpen: false})}
                                                    style={{margin: 0, fontSize: 14}}><i
                                                className="glyphicon glyphicon-remove"/> Cancel
                                            </button>
                                            <button type="button" className="btn btn-sm btn-danger"
                                                    onClick={this.restoreAdminUsers}
                                                    style={{margin: 0, marginLeft: 5, fontSize: 14}}><i
                                                className="glyphicon glyphicon-ok"/> Restore
                                            </button>
                                        </form>
                                    </div>
                                </Modal>

                        <Modal
                            isOpen={this.state.modalPinChangeIsOpen}
                            style={customManageUsersStyles}
                            contentLabel="Activation"
                        >
                            <div className="modal-header">
                                <h5 className="modal-title modal-title-color col-md-6" id="deleteLabel">Pin</h5>
                                <div className="col-md-6"><button type="button" className="pull-right color-1" onClick={(e) => this.closePinChangeModal(e)}>X</button></div>
                            </div>
                            <div className="modal-body">
                            <form onSubmit={(e) => this.handlePinSubmit(e,userID,oldPin)}>
                                           
                                                <div className="form-group clearfix">
                                               
                                               
                                                    <label className="col-md-5 control-label" >
                                                       New Pin*:</label>
                                                       <div className="col-md-6">
                                                    <input  name="pin"
                                                        className="form-control" id="pin" onKeyUp={this.checkPin}
                                                        placeholder="New Pin" type="text" maxlength="4" onKeyPress={pinFormtFun} 
                                                        onChange={(e) => this.handlePinChangeValue(e)} 
                                                         required /></div>
                                                          </div>
                                                          <div className="form-group clearfix">
                                                          <label className="col-md-5 control-label" >
                                                        Confirm Pin*:</label>
                                                        <div className="col-md-6">
                                                    <input  name="cpin"
                                                        className="form-control" id="cpin" onKeyUp={this.checkPin}
                                                        placeholder="confirm Pin" type="text" maxlength="4" onKeyPress={cPinFormtFun} 
                                                         required />
                                                         <span id='pinMessage'></span>
                                                         </div>
                                                         
                                                </div>
                                           
                                    <div className="col-md-12 col-sm-12 col-xs-12">
                                       
                                        <button className="btn btn-success btn-xs pull-right" 
                                        type="submit"  id="submitPin"
                                        /* onClick={(e) => this.handlePinSubmit(userID)} */
                                             style={{ margin: 0}}>Save
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </Modal>

        </div>
        {/* <div className="text-right">
                        <ul className="pagination">
                            {this.state.currentPage > 0 &&
                            <li>
                                <button className="btn btn-primary " onClick={this.previousPage} type="button">Previous
                                </button>
                            </li>
                            }
                            {((this.state.currentPage + 1) * 5 < this.state.schoolList.length) &&
                            <li>
                                <button className="btn btn-success " onClick={this.nextPage} type="button">Next
                                </button>
                            </li>
                            }
                        </ul>
                    </div> */}
                   <div className="row">
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <p className="App-intro">
                                <a href="javascript:void(0);"
                                   onClick={() => this.handleClick()}>Inactive Users
                                </a>
                            </p>

                            <ToggleDisplay show={this.state.show}>

                                <p><b><i> These are the inactive users. Click on restore to undo the
                                    action.</i></b>
                                </p>
                                <div className="table-responsive ">
                                    <table className="table table-hover">
                                        <thead>
                                        <tr className="bg-success base-reverse">
                                            <th>NAME</th>                                    
                                            <th>PHONE</th>
                                            <th>EMAIL ID</th>
                                            <th className="text-center">UNSUBSCRIBE</th>
                                            <th className="text-center" style={{width:'124px'}}>ACTION</th>
                                        </tr>
                                        </thead>
                                        <tbody>

                                        {
                                        this.state.schoolList.map(col =>{
                                            if(!col.isActive)
                                            return (<tr>
                                                <td>{col.firstName} {col.lastName}</td>                                              
                                                <td>{col.mobileNo}</td>
                                                <td><div>
                                                        <span>                                                          
                                                                <img alt="action"
                                                                     onClick=""
                                                                     src={col.isActive === true ? (col.isVerified === true ? active : warn) : deleted}
                                                                     style={{
                                                                         paddingRight: '5px',
                                                                         cursor: 'pointer',
                                                                         width: '22px'
                                                                     }}/>
                                                                {col.username}                                                        
                                                            </span>
                                                        </div></td>
                                                <td className="text-center">{col.isUnsubscribeGenNotif ? <i className="fa fa-check bg-color-2" style={tickstyles} aria-hidden="true"></i>:<i className="fa fa-times bg-color-light-grey" style={tickstyles} aria-hidden="true"></i>}</td>
                                                <td className="actions text-center" style={{whiteSpace: 'nowrap'}}>
                                                        <div>
                                                            <a href="javascript:void(0);"
                                                               onClick={() => this.restoreAdminUser(col)}>Restore
                                                                </a>
                                                        </div>
                                                </td>
                                            </tr>)
                                        })
                                    }
                                        </tbody>
                                    </table>

                                </div>
                            </ToggleDisplay>
                        </div>
                    </div>     
        </div>
        </div>           
        );
    }
}
export default ManageUsers;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/ManageUsers/manageUsers.jsx